import { format } from "date-fns";

const getDate = (d: string | number | undefined): string =>
  d ? format(new Date(d), "dd.MM.yyyy") : "";

export default getDate;
